import useIsInMobileStickyNavExperiment from './useIsInMobileStickyNavExperiment';

const useGetMobileStickyBannerHeight = () => {
  const isInStickyNavExperiment = useIsInMobileStickyNavExperiment();

  return isInStickyNavExperiment ? 128 : 104;
};

export default useGetMobileStickyBannerHeight;
